import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useErrorHandler, useAuth } from '@hooks';
import { LoginForm } from '@components';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const { error, isLoading, handleAsync, clearError } = useErrorHandler();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (email: string, password: string) => {
    clearError();

    if (!email || !password) return;

    const result = await handleAsync(() => login(email, password));

    if (result !== null) {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md p-8 bg-white shadow-md rounded-xl">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-800">Bienvenido</h1>
          <p className="mt-2 text-gray-600">Inicia sesión en tu cuenta de Fixionity</p>
        </div>

        {error && (
          <div className="p-4 mb-6 border-l-4 border-red-500 bg-red-50">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">{error.message}</p>
              </div>
            </div>
          </div>
        )}

        <LoginForm
          isLoading={isLoading}
          onSubmit={handleSubmit}
          onSocialLogin={() => {
            // Handle Google login here
            console.log('Google login clicked');
            login('', '');
            navigate(from, { replace: true });
          }}
        />

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            No tienes una cuenta?{' '}
            <Link to="/signup" className="font-medium text-blue-600 hover:text-blue-500">
              Regístrate
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;